import { useTheme } from '../components/styles/styles';

export const UnitIcon = () => {
  const theme = useTheme();

  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.16665 11.7166H7.16665V9.49998H8.88331V7.28331H10.6V5.04998H11.8333C11.9444 5.04998 12.0361 5.01387 12.1083 4.94165C12.1805 4.86942 12.2166 4.77776 12.2166 4.66665C12.2166 4.55554 12.1805 4.46387 12.1083 4.39165C12.0361 4.31942 11.9444 4.28331 11.8333 4.28331H9.83331V6.49998H8.11665V8.71665H6.39998V10.95H5.16665C5.05554 10.95 4.96387 10.9861 4.89165 11.0583C4.81942 11.1305 4.78331 11.2222 4.78331 11.3333C4.78331 11.4444 4.81942 11.5361 4.89165 11.6083C4.96387 11.6805 5.05554 11.7166 5.16665 11.7166ZM3.79998 13.6666C3.53331 13.6666 3.30554 13.5722 3.11665 13.3833C2.92776 13.1944 2.83331 12.9666 2.83331 12.7V3.29998C2.83331 3.03331 2.92776 2.80554 3.11665 2.61665C3.30554 2.42776 3.53331 2.33331 3.79998 2.33331H13.2C13.4666 2.33331 13.6944 2.42776 13.8833 2.61665C14.0722 2.80554 14.1666 3.03331 14.1666 3.29998V12.7C14.1666 12.9666 14.0722 13.1944 13.8833 13.3833C13.6944 13.5722 13.4666 13.6666 13.2 13.6666H3.79998Z"
        fill={theme.text.disabled2}
      />
    </svg>
  );
};
